import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

const links = [["The Book", "/#the-book", "book"], ["How It Works", "/#how", "how"], ["Made For", "/#made-for", "made-for"], ["FAQs", "/#faqs", "faqs"]];
export default function SiteHeader({ showNav = true }) {
  const [open, setOpen] = useState(false);
  const trigger = useRef(null);
  const location = useLocation();
  useEffect(() => setOpen(false), [location]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    const close = (e) => { if (e.key === "Escape" && open) { setOpen(false); trigger.current?.focus(); } };
    window.addEventListener("keydown", close);
    return () => { window.removeEventListener("keydown", close); document.body.style.overflow = ""; };
  }, [open]);
  const shut = () => setOpen(false);
  return <header className="site-header" data-testid="site-header">
    <div className="brand-container header-inner">
      <BrandLogo testId="logo-link" onClick={shut}/>
      {showNav ? <nav className="desktop-nav" aria-label="Main navigation" data-testid="desktop-navigation">
        {links.map(([label, href, id]) => <Link key={id} to={href} data-testid={`nav-${id}`}>{label}</Link>)}
      </nav> : <span/>}
      <div className="header-actions">
        <Link to="/projects" className="saved-link" data-testid="header-saved-books">Your books</Link>
        {showNav && <Link to="/create/new" className="btn-primary header-create" data-testid="header-create-cta"><span className="long-cta">Create Your Keepsake</span><span className="short-cta">Create</span></Link>}
        <button ref={trigger} onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Close menu" : "Open menu"} className="mobile-menu-button" data-testid="mobile-menu-toggle">{open ? <X size={24} strokeWidth={1.5}/> : <Menu size={24} strokeWidth={1.5}/>}</button>
      </div>
    </div>
    {open && <nav className="mobile-nav" id="mobile-menu" aria-label="Mobile navigation" data-testid="mobile-navigation">
      <div className="mobile-nav-links">{links.map(([label, href, id]) => <Link key={id} to={href} onClick={shut} data-testid={`mobile-nav-${id}`}>{label}<ArrowRight size={20} strokeWidth={1.5}/></Link>)}</div>
      <div className="mobile-nav-footer">
        <Link to="/create/new" onClick={shut} className="btn-primary" data-testid="mobile-create-cta">Create Your Keepsake <ArrowRight size={16}/></Link>
        <Link to="/projects" onClick={shut} className="text-link" data-testid="mobile-saved-books">Your saved books</Link>
      </div>
    </nav>}
  </header>;
}
